// ------------------------REGARDING FOR STATIC CONTENT  ------------------------------------------
import logoImage from '../assets/images/logo.png'; 
const websiteName = "Finovate";  
const websiteTagline = "Innovative solutions for financial growth.";  
const websiteUrl = "https://www.Finovate.com";  
const logoUrl = logoImage;
const androidAppLink = "android-app://com.finovate.sura_user";
const iosAppLink = "ios-app://com.finovate.sura_user";    
const currentLocation = sessionStorage.getItem('country');  
const currencyIcon = currentLocation === 'India' ? '₹' : '$';


// ----------------------- REGARDING FOR SEO / META TAG   -----------------------------------------------
window.logoUrl = logoImage;
window.dynamicAndroidAppLink = "https://play.google.com/store/apps/details?id=com.example";
window.dynamicIosAppLink = "https://apps.apple.com/us/app/example/id123456789";
window.dynamicWebsiteName = websiteName;
window.websiteTagline = 'Innovative solutions for financial growth.';
window.websiteUrl = 'https://www.finovate.com';
window.metaOgDescription = `Explore ${websiteName}, your trusted partner in legal and financial services, offering expert solutions to secure your future and achieve your goals...`;
window.metatwitterDescription = `Explore ${websiteName}, your trusted partner in legal and financial services, supporting your journey to success and financial security...`;
const metaDescriptionEn = `Explore ${websiteName}, your trusted partner in legal and financial services, providing personalized advice and comprehensive solutions to meet your unique needs and aspirations...`;
const metaDescriptionTh = `สำรวจ ${websiteName} พันธมิตรที่คุณไว้วางใจในบริการด้านกฎหมายและการเงิน, ให้คำปรึกษาเฉพาะทางและโซลูชันที่ครอบคลุมเพื่อตอบสนองความต้องการและเป้าหมายของคุณ...`;
const keywordsTemplate = {
    en: {
      static: "Legal Services, Financial Solutions, Expert Advice, Personalized Support",
      dynamic: `${websiteName}`
    },
    th: {
      static: "บริการด้านกฎหมาย, โซลูชั่นการเงิน, คำแนะนำจากผู้เชี่ยวชาญ, การสนับสนุนเฉพาะบุคคล",
      dynamic: `${websiteName}`
    }
  };




export {
  websiteName,
  websiteTagline,
  websiteUrl,
  logoUrl,
  currencyIcon,
  metaDescriptionEn,
  metaDescriptionTh,
  keywordsTemplate,
  androidAppLink,
  iosAppLink,
};